import { useSyncExternalStore } from 'react';
import { api } from '../api.ts';
import { typeOfMake } from './boxTypes.ts';

const known = new Map<string, string | null>();
const asked = new Set<string>();
const listeners = new Set<() => void>();
let version = 0;
let queued: string[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

const emit = () => { version += 1; listeners.forEach((l) => l()); };

async function flush() {
  timer = null;
  const batch = queued;
  queued = [];
  if (batch.length === 0) return;
  try {
    const res = await api.get<{ makes: Record<string, string> }>(
      `/api/reference/job-makes?numbers=${encodeURIComponent(batch.join(','))}`);
    for (const n of batch) known.set(n, res.makes[n] ?? null);
  } catch {
    for (const n of batch) asked.delete(n);
  }
  emit();
}

function want(number: string) {
  if (asked.has(number)) return;
  asked.add(number);
  queued.push(number);
  if (!timer) timer = setTimeout(() => { void flush(); }, 30);
}

const subscribe = (l: () => void) => { listeners.add(l); return () => { listeners.delete(l); }; };

export function resetJobMakes() {
  known.clear();
  asked.clear();
  emit();
}

export function MakeTag({ number }: { number: string | null | undefined }) {
  useSyncExternalStore(subscribe, () => version);
  if (!number) return null;
  want(number);
  const make = known.get(number);
  if (!make) return null;
  const t = typeOfMake(make);
  return <span className="make-tag" title={t.label}>{t.short}</span>;
}
